import { Component } from 'react';
import dynamic from 'next/dynamic';
import { QueryBranchMapPage } from './gql/queryBranchMap';
import { QueryLuckyOcbPage } from './gql/queryLuckyOcb';
import { QueryPayoutTime } from './gql/queryPayoutTime';
import { QuerySellingHours } from './gql/querySellingHours';

export type FrontendPageComponentValue =
    | 'LuckyOCBComponent'
    | 'BranchMapPageComponent'
    | 'PayoutTimePageComponent'
    | 'SellingHoursPageComponent';
export interface PageModel {
    component: React.ComponentType<any>;
    query: string;
}
export const AppContent = dynamic(() => import('@components/app-content/AppContent'));

export const pageMapping: Readonly<Record<FrontendPageComponentValue, Readonly<PageModel>>> = {
    LuckyOCBComponent: {
        component: dynamic(() => import('@components/app-lucky-ocb/AppLuckyOCB')),
        query: QueryLuckyOcbPage,
    },
    BranchMapPageComponent: {
        component: dynamic(() => import('@components/app-branch-map/AppBranchMap')),
        query: QueryBranchMapPage,
    },
    PayoutTimePageComponent: {
        component: AppContent,
        query: QueryPayoutTime,
    },
    SellingHoursPageComponent: {
        component: dynamic(() => import('@components/app-selling-hours/AppSellingHours')),
        query: QuerySellingHours,
    },
};
